"use strict";

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = match;
exports.matchMSISDNEntry = matchMSISDNEntry;
exports.matchPINEntry = matchPINEntry;
exports.whenMSISDNEntry = whenMSISDNEntry;
exports.whenPINEntry = whenPINEntry;
exports.default = exports.isPINEntry = exports.isMSISDNEntry = exports.mockedCompletedState = exports.mockedPINState = exports.initialState = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("regenerator-runtime/runtime");

var React = _interopRequireWildcard(require("react"));

var _main = _interopRequireDefault(require("./main"));

var RDS = _interopRequireWildcard(require("../../common-types/RemoteDataState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  type: "MSISDNEntry",
  result: RDS.NothingYet()
};
exports.initialState = initialState;
var mockedPINState = {
  type: "PINEntry",
  result: RDS.NothingYet()
};
exports.mockedPINState = mockedPINState;
var mockedCompletedState = {
  type: "Completed",
  result: {
    finalUrl: 'https://www.yahoo.com/'
  }
}; // export const initialState : State = { type: "PINEntry", result: RDS.NothingYet<PINEntryFailure, PINEntrySuccess>()}

exports.mockedCompletedState = mockedCompletedState;

function match(_ref) {
  var msisdnEntry = _ref.msisdnEntry,
      pinEntry = _ref.pinEntry,
      completed = _ref.completed;
  return function (state) {
    switch (state.type) {
      case 'MSISDNEntry':
        return msisdnEntry(state.result);

      case 'PINEntry':
        return pinEntry(state.result);

      case 'Completed':
        return completed(state.result);
    }
  };
}

function matchMSISDNEntry(m) {
  return RDS.match(m);
}

function matchPINEntry(m) {
  return RDS.match(m);
}

var isMSISDNEntry = function isMSISDNEntry(s) {
  return s.type == "MSISDNEntry";
};

exports.isMSISDNEntry = isMSISDNEntry;

var isPINEntry = function isPINEntry(s) {
  return s.type == "PINEntry";
};

exports.isPINEntry = isPINEntry;

function whenMSISDNEntry(f) {
  return function (s) {
    if (isMSISDNEntry(s)) {
      return f(s.result);
    }
  };
}

function whenPINEntry(f) {
  return function (s) {
    if (isPINEntry(s)) {
      return f(s.result);
    }
  };
}

var _default = function _default(tracker, Comp, strategy) {
  return function (initialState) {
    var _temp;

    var HOC = (_temp = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(HOC, _React$PureComponent);

      var _super = _createSuper(HOC);

      function HOC(props) {
        var _this;

        _classCallCheck(this, HOC);

        _this = _super.call(this, props);

        _defineProperty(_assertThisInitialized(_this), "state", void 0);

        var self = _assertThisInitialized(_this);

        _this.state = {
          currentState: initialState,
          actions: {
            backToStart: function backToStart() {
              _this.setState({
                currentState: initialState
              });
            },
            submitMSISDN: function () {
              var _submitMSISDN2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _len,
                    args,
                    _key,
                    msisdn,
                    msisdnSubmissionResult,
                    _submitPIN,
                    errorType,
                    _args2 = arguments;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.setState({
                          currentState: {
                            type: "MSISDNEntry",
                            result: RDS.Loading()
                          }
                        });

                        for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                          args[_key] = _args2[_key];
                        }

                        msisdn = args[2];
                        tracker.advancedInFlow('tallyman.v1-pin', 'msisdn-submitted', {
                          msisdn: msisdn
                        });

                        if (strategy) {
                          args[3] = strategy;
                        }

                        _context2.prev = 5;
                        _context2.next = 8;
                        return _main.default.apply(void 0, args);

                      case 8:
                        msisdnSubmissionResult = _context2.sent;
                        _submitPIN = msisdnSubmissionResult.submitPIN;
                        tracker.advancedInFlow('tallyman.v1-pin', 'msisdn-submission-success', {
                          msisdn: msisdn
                        });
                        self.setState({
                          currentState: {
                            type: "PINEntry",
                            result: RDS.NothingYet(),
                            actualPIN: msisdnSubmissionResult.type == "SingleMSISDNSubmissionResult" ? msisdnSubmissionResult.pin : null
                          },
                          actions: _objectSpread(_objectSpread({}, self.state.actions), {}, {
                            submitPIN: function () {
                              var _submitPIN2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pin) {
                                var _result, errorType;

                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        _this.setState({
                                          currentState: {
                                            type: "PINEntry",
                                            result: RDS.Loading()
                                          }
                                        });

                                        tracker.advancedInFlow('tallyman.v1-pin', 'pin-submitted', {
                                          msisdn: msisdn,
                                          pin: pin
                                        });
                                        _context.prev = 2;
                                        _context.next = 5;
                                        return _submitPIN(pin);

                                      case 5:
                                        _result = _context.sent;
                                        tracker.advancedInFlow('tallyman.v1-pin', 'pin-submission-success', {
                                          msisdn: msisdn,
                                          pin: pin,
                                          finalUrl: _result
                                        }); // automatically transition to Completed state

                                        _this.setState({
                                          currentState: {
                                            type: "Completed",
                                            result: {
                                              finalUrl: _result
                                            }
                                          }
                                        });

                                        _context.next = 16;
                                        break;

                                      case 10:
                                        _context.prev = 10;
                                        _context.t0 = _context["catch"](2);
                                        console.error(_context.t0);
                                        errorType = "InvalidPIN" === _context.t0.type ? "InvalidPIN" : "UnknownError";
                                        self.setState({
                                          currentState: {
                                            type: "PINEntry",
                                            result: RDS.Failure({
                                              errorType: errorType
                                            })
                                          }
                                        });
                                        tracker.recedeInFlow('tallyman.v1-pin', 'pin-submission-failure', {
                                          msisdn: msisdn,
                                          pin: pin
                                        });

                                      case 16:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, null, [[2, 10]]);
                              }));

                              function submitPIN(_x) {
                                return _submitPIN2.apply(this, arguments);
                              }

                              return submitPIN;
                            }()
                          })
                        });
                        _context2.next = 20;
                        break;

                      case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](5);
                        console.warn(_context2.t0);
                        errorType = "AlreadySubscribed" === _context2.t0.type ? "AlreadySubscribed" : "InvalidMSISDN" === _context2.t0.type ? "InvalidMSISDN" : "UnknownError";
                        self.setState({
                          currentState: {
                            type: "MSISDNEntry",
                            result: RDS.Failure({
                              errorType: errorType,
                              error: _context2.t0,
                              productUrl: _context2.t0.productUrl
                            })
                          }
                        });
                        tracker.recedeInFlow('tallyman.v1-pin', 'msisdn-submission-failure', {
                          msisdn: msisdn,
                          errorType: errorType || 'UnknownError'
                        });

                      case 20:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[5, 14]]);
              }));

              function submitMSISDN() {
                return _submitMSISDN2.apply(this, arguments);
              }

              return submitMSISDN;
            }(),
            submitPIN: function submitPIN(_pin) {
              return self.setState({
                currentState: {
                  type: "PINEntry",
                  result: RDS.Failure({
                    errorType: "TooEarly"
                  })
                }
              });
            }
          }
        };
        return _this;
      }

      _createClass(HOC, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(Comp, _extends({}, this.props, {
            currentState: this.state.currentState,
            actions: this.state.actions,
            strategyConfig: strategy ? strategy : undefined
          }));
        }
      }]);

      return HOC;
    }(React.PureComponent), _temp);
    HOC.prototype['_client'] = "tallyman.v1-pin";
    return HOC;
  };
};

exports.default = _default;